import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=6cb9b796&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=ts&"
export * from "./TextArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=6cb9b796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9b796",
  null
  
)

export default component.exports